import {ApiTags, createBaseApi} from "../../config";
import {userServices} from "./user.services";
import {
    fetchRelatedContentParams,
    ILogin,
    ID_Params,
    IProfile,
    AuthResponse,
    ValidateTokenResponse,
    AvatarsResponse,
    IProfileById, GetProfileResponse, AddToListParams, ValidateTokenParams,
} from "./user.interfaces";


export const userQueries = createBaseApi("userApi").injectEndpoints({
        endpoints: (builder) => ({
            authSignUp: builder.mutation<AuthResponse, ILogin>({
                query: (body) => userServices.authSignUp(body)
            }),
            getValidateToken: builder.query<ValidateTokenResponse, ValidateTokenParams | void>({
                query: (params) => userServices.getValidateToken(params || undefined)
            }),
            getAvatars: builder.query<AvatarsResponse[], void>({
                query: () => userServices.getAvatars()
            }),
            getProfiles: builder.query<Array<GetProfileResponse>, void>({
                query: () => userServices.getProfiles(),
                providesTags: [ApiTags.PROFILES]
            }),
            getProfilesById: builder.query<IProfileById, ID_Params>({
                query: (id) => userServices.getProfilesById(id),
                providesTags: (_result, _error, id) => [
                        { type: ApiTags.PROFILE, id }
                ]
            }),
            getList: builder.query<void, string>({
                query: (id) => userServices.getList(id)
            }),
            deleteToList: builder.mutation<void, AddToListParams>({
                query: ({ params, body }) =>
                    userServices.deleteToList(params, body),
                }),
            getWatchingList: builder.query<void, ID_Params>({
                query: (id) => userServices.getWatchingList(id)
            }),
            addToList: builder.mutation<void, AddToListParams>({
                query: ({params, body}) => userServices.addToList(params, body),
            }),
            continueWatchingList: builder.mutation<void, AddToListParams>({
                query: ({params, body}) => userServices.continueWatchingList(params, body),
                invalidatesTags: (_result, _error, {body}) => [
                    {type: ApiTags.VIDEO, id: String(body.content)},
                ],
            }),
            deleteWatchingItem: builder.mutation<void, AddToListParams>({
                query: ({params, body}) =>
                    userServices.deleteWatchingItem(params, {
                        content: body.content,
                        client_ip: body.client_ip,
                    }),
                invalidatesTags: (_result, _error, {body}) => [
                    {type: ApiTags.VIDEO, id: String(body.content)},
                ],
            }),
            updateProfile: builder.mutation<any, { id: ID_Params, body: IProfile }>({
                query: ({id, body}) => userServices.updateProfile(id, body),
                invalidatesTags: (_result, _error, { id }) => [
                    { type: ApiTags.PROFILE, id },
                    ApiTags.PROFILES,
                ]
            }),
            createProfile: builder.mutation<any, Partial<IProfile>>({
                query: (body) => userServices.createProfile(body),
                invalidatesTags: [ApiTags.PROFILES]
            }),
            deleteProfile: builder.mutation<void, ID_Params>({
                query: (id) => userServices.deleteProfile(id),
                invalidatesTags: [ApiTags.PROFILES]
            }),
            fetchRelatedContent:
                builder.mutation<void, fetchRelatedContentParams>({
                    query: ({params, body}) => userServices.fetchRelatedContent(params, body),
                }),
        })
    })
;

export const {
    useAuthSignUpMutation,
    useLazyGetValidateTokenQuery,
    useGetAvatarsQuery,
    useLazyGetListQuery,
    useLazyGetWatchingListQuery,
    useCreateProfileMutation,
    useGetProfilesQuery,
    useDeleteProfileMutation,
    useGetProfilesByIdQuery,
    useAddToListMutation,
    useUpdateProfileMutation,
    useContinueWatchingListMutation,
    useDeleteWatchingItemMutation,
    useFetchRelatedContentMutation,
    useDeleteToListMutation
} = userQueries;
